import React from 'react';
import PropTypes from 'prop-types';
import ResizeObserver from 'resize-observer-polyfill';

export class ElementResize extends React.Component {
  state = { rect: {} };

  componentDidMount() {
    this.ro = new ResizeObserver(entries => {
      for (const entry of entries) {
        if (entry.target === this.ref) {
          // update state if this is our DOM Node
          // (we may support multiple refs)
          this.setState({ rect: entry.contentRect });
        }
      }
    });
    // observe the passed in ref
    this.ro.observe(this.ref);
  }

  componentWillUnMount() {
    this.ro.disconnect();
  }

  render() {
    const { rect } = this.state;
    const { children } = this.props;
    return children(rect, ref => (this.ref = ref));
  }
}

ElementResize.propTypes = {
  children: PropTypes.func.isRequired,
};

export default ElementResize;


// WEBPACK FOOTER //
// ./src/components/common/ElementResize.js